// первое свойство которые выбрали для фильтрации
let filterFirstField = '';

// Применить фильтры
function attachFilters(reload = false) {
    loadPath(getPathWithFilters(generateFilters()), reload);
}

/**
 * Generate fiters
 * @returns {{}}
 */
function generateFilters() {
    let form = $('#filter-form'),
        values = form.serializeArray(),
        filters = {},
        sort = $('#sort__block').find('.sort-block__item.active').attr('data-value'),
        numbers = $('#numbers__block').find('.sort-block__item.active').attr('data-value');
    // Parse filters
    $(values).each(function (index, obj) {
        if (obj.value !== '') {
            if (filters[obj.name]) {
                filters[obj.name] += ',' + obj.value;
            } else {
                filters[obj.name] = obj.value;
            }

            if (filterFirstField.length == 0) {
                filterFirstField = obj.name;
            }
        }
    });

    if (parseInt(Object.keys(filters).length) == 1) {
        // первый ключ объекта
        let firstKey = function (obj) {
            for (var key in obj)
                if (Object.getOwnPropertyDescriptor(obj, key))
                    return key;
        };

        $(filters).each(function (i, obj) {
            $(obj).each(function (code, itemValues) {
                if (firstKey(itemValues) != 'sort' && firstKey(itemValues) != 'numbers') {
                    filterFirstField = firstKey(itemValues);
                }
            });
        });
    }

    // Add sort
    if (sort) {
        filters['sort'] = sort;
    }

    // Add limit page
    if (numbers) {
        filters['numbers'] = numbers;
    }

    return filters;
}

// Add filters to path
function getPathWithFilters(filters) {
    let targetUrl = window.location.pathname;
    if(window.targetUrl){
        targetUrl = window.targetUrl;
    }
    
    let pathArray = targetUrl.split('/').filter(value => value !== ''),
        isCatalogPage = $('#catalog-page-block').length !== 0,
        getParams = window.location.search.substr(1),
        replaceIndex = null;



    // Detect if filters are already present in path
    for (let i in pathArray) {
        if (pathArray[i].indexOf('=') !== -1) {
            pathArray[i].split(';').forEach(value => {
                let filterArr = value.split('=');
                if (['categories', 'text'].indexOf(filterArr[0]) !== -1) {
                    // Take filters from path and put them to new filters
                    filters[filterArr[0]] = filterArr[1];
                }
            })
            replaceIndex = i;
        }
    }

    // Convert filters to string
    let filtersString = '';
    for (let i in filters) {
        filtersString += i + '=' + filters[i] + ';'
    }
    
    if (filtersString.length > 0 && filterFirstField.length > 0) {
        filtersString += 'start=' + filterFirstField + ';';
    }

    filtersString = filtersString.slice(0, -1);

    // Add filters to path
    if (replaceIndex) {
        if (pathArray[replaceIndex] === filtersString && (filtersString.indexOf(';') > -1)) {
            // Not attach filters if previous filters has been the same
            return;
        }
        pathArray[replaceIndex] = filtersString
    } else {
        if (isCatalogPage) {
            // If this is on catalog page just add filters to the end
            pathArray.push(filtersString)
        } else {
            // If current page is not catalog then put filter as main
            pathArray = [filtersString];
        }
    }

    if (pathArray[0] != 'categories' && pathArray[0].indexOf('=') == 0) {
        isCatalogPage = false;
        pathArray.splice(0, 1);
    }

    // применяя фильтрацию перемещаемся на первую страницу
    for (let i in pathArray) {
        if (pathArray[i].indexOf('page-') !== -1) {
            pathArray.splice(i, 1);
        }
    }
    

    let path = pathArray.join('/'),
        lang = $('html').attr('lang');

    if (lang === 'ru' && pathArray[0] !== 'ru') {
        lang = '/ru';
    } else {
        lang = '';
    }

    if (isCatalogPage) {
        path = '/' + path;
    } else {
        path = '/categories/' + path
    }



    return lang + path + '/';
}

function loadPath(path, reload = false) {
   
    currentFilters();
    
    if (!path) {
        return;
    }
    let isCatalogPage = $('#catalog-page-block').length !== 0;
    

    if (isCatalogPage) {
        // if (getParams) {
        //     path += '?' + getParams;
        // }


        if (reload) {
            window.location.replace(path);
        }
        else {
            let selectorGridBlock = 'catalog-page-block';

            let itemsBlock = $('#'+selectorGridBlock);
            let paginationBlock = $('#catalog-page-block').find('.pagination-block');

            history.pushState({}, null, path);

            $.get({
                cache: false,
                'url': path + '?ajax=1',
                dataType: "json",

                success: function (data) {
                    let content = data.resource.html;
                    if (content) {
                        // список товаров
                        itemsBlock.find('.grid-wrapper').removeClass('empty-block').html(content);
                        if(parseInt(data.resource.data.total) == 0){
                            itemsBlock.find('.grid-wrapper').addClass('empty-block');
                        }

                        // пагинация
                        paginationBlock.html(data.pagination.html);

                        // переопределить фильтр
                        let dataFilters = data.filters.data;
                        let form = $('#filter-form');
                        
                        if(dataFilters.selected_count){
                            $('.button-clear').addClass('d-block');
                            $('.button-next').addClass('d-block');
                        } else {
                            $('.button-clear').removeClass('d-block');
                            $('.button-next').removeClass('d-block');
                        }
                        // активность элементов при применении фильтра
                        $.each(dataFilters.filters, function (key, item) {
                            
                            let containerOptions = form.find('.accordion-item[data-id="' + item.id + '"]');
                            $.each(item.options, function (k, option) {
                                var wrapperInput = containerOptions.find('.accordion-content');
                                
                                wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"] p').text(option.title);
                                if (!option.available) {
                                    wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').addClass('disabled');
                                }
                                else {
                                    wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').removeClass('disabled');
                                }
                            });
                        });
                    }
                    else {
                        // список товаров
                        itemsBlock.find('.grid-wrapper').addClass('empty-block').append('<div class="empty-catalog-text">Отсутствуют товары выборки</div>');

                        // пагинация
                        paginationBlock.html('');
                    }
                },
                error: function (data) {
                    console.log('Error');
                }
            });
        }
    } else {
        if (path.indexOf('categories/sort=min_price') === -1) {
            // Применить фильтр только если были хоть какие-нибудь изменения
            window.location.replace(path);
        }
    }
}

/**
 * Send ajax
 * @param path
 * @param success
 */
function sendAjax(path, success) {
    if (!path) {
        return;
    }
    $.get({
        'url': path,
        dataType: "json",
        success: success,
        error: function (data) {
            console.log('Error');
        }
    });
}

// Проверить активные фильтры
function currentFilters() {
    let filters = generateFilters();
    let activeFilters = [];
    let filterCountBlock = $('.selected-filter-count').length != 0;

    for (var key in filters) {
        if (key != 'sort' && key != 'numbers') {
            filters[key].split(',').forEach(el => {
                activeFilters.push(el)
            })
        }
    }

    
    if(filterCountBlock){
        if(activeFilters.length != 0){
            $('.selected-filter-count').text(`(${activeFilters.length})`).show();
            $('.del-filters').addClass('show')
        }else{
            $('.selected-filter-count').text(`(${activeFilters.length})`).hide();
            $('.del-filters').removeClass('show')
        }
    }
    return activeFilters
}

function shadowBody(x) {
    if (x) {
        $('#app').css('overflow', 'hidden')
        $('body').addClass('shadow')
        $('header').addClass('shadow')
    } else {
        $('#app').css('overflow', 'auto')
        $('body').removeClass('shadow')
        $('header').removeClass('shadow')
    }
};

$(function () {
    let langPrefix = $('html').attr('lang') === 'ru' ? '/ru' : '';
    let token = $('meta[name="csrf-token"]').attr('content');
    let activeFilters = currentFilters();
    let filterCountBlock = $('.selected-filter-count').length != 0;
    if(filterCountBlock){
        if(activeFilters.length != 0){
            $('.selected-filter-count').text(`(${activeFilters.length})`).show();
        }else{
            $('.selected-filter-count').text(`(${activeFilters.length})`).hide();
        }
    }

    $(document).on('click','.button-clear, .desc-button-clear', function(e){
        e.preventDefault();
        //$('.accordion-item .custom-checkbox[data-id] input').removeAttr('checked');      
        $('.accordion-item .custom-checkbox[data-id] input').filter(':checked').prop('checked', false);
        let path = getPathWithFilters(
            generateFilters()
        );

        if (!path) {
            return;
        }
        path = path.replace('/categories/', '/filters/');

        sendAjax(
            path,
            function (response) {
                // переопределить фильтр
                let dataFilters = response.filters;
                let form = $('#filter-form');
                // активность элементов при применении фильтра
                $.each(dataFilters.filters, function (key, item) {
                    let containerOptions = form.find('.accordion-item[data-id="' + item.id + '"]');
                    $.each(item.options, function (k, option) {
                        var wrapperInput = containerOptions.find('.input-wrapper');
                        
                        wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"] p').text(option.title);

                        if (!option.available) {
                            wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').addClass('disabled');
                        }
                        else {
                            wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').removeClass('disabled');
                        }
                    });
                });
            }
        )

        if ($('#catalog-page-block').length !== 0) {
            attachFilters();
        }  
    });

    /**
    * Upgrading total products information
    */
    $('#filter-form input[type=checkbox]').change(function () {
        let path = getPathWithFilters(
            generateFilters()
        );

        if (!path) {
            return;
        }
        path = path.replace('/categories/', '/filters/');

        sendAjax(
            path,
            function (response) {
                // переопределить фильтр
                let dataFilters = response.filters;
                let form = $('#filter-form');
                // активность элементов при применении фильтра
                $.each(dataFilters.filters, function (key, item) {
                    let containerOptions = form.find('.accordion-item[data-id="' + item.id + '"]');
                    $.each(item.options, function (k, option) {
                        var wrapperInput = containerOptions.find('.input-wrapper');
                        
                        wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"] p').text(option.title);

                        if (!option.available) {
                            wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').addClass('disabled');
                        }
                        else {
                            wrapperInput.find('.custom-checkbox[data-id="' + option.id + '"]').removeClass('disabled');
                        }
                    });
                });
            }
        )

        if ($('#catalog-page-block').length !== 0) {
            attachFilters();
        }
    });
    
    $('#sort__block .sort-block__item, #numbers__block .sort-block__item').on('click', function () { 
        $(this).addClass('active').siblings().removeClass('active')

        let numbersBlock = $('#numbers__block').find('.sort-block__item.active'),
            name = $(this).attr('data-name');

            console.log(numbersBlock);
            console.log(name);
            
        if (numbersBlock) {
            if (name) {
                if ($('#sort__block').hasClass('attachFilter')) {
                    // Trigger filter
                    attachFilters(true);
                }
            }
        }
    });

    $(document).on('click', '.load-more', function (e) {
        e.preventDefault();
        let that = this;
        $(that).addClass('loading');

        let url = $(this).attr('href'),
            itemsBlock = $('#' + $(this).data('block')),
            paginationBlock = $(this).closest('.pagination-block');

        if (itemsBlock.length === 0) {
            console.error('Items block not found for loading items');
        }

        if(window.targetUrl){
            url = url.split(window.location.pathname).join('/'+window.targetUrl+'/');
        }

        history.pushState({}, null, url);
        $.get({
            cache: false,
            'url': url + '?ajax=1',
            dataType: "json",
            success: function (data) {
                $(that).removeClass('loading');
                let content = data.resource.html;
                if (content) {
                    // список товаров
                    itemsBlock.find('.grid-wrapper').removeClass('empty-block').append(data.resource.html);
                    if(Object.keys($(content)).length == 0){
                        itemsBlock.find('.grid-wrapper').addClass('empty-block');
                    }
                                        
                    paginationBlock.html(data.pagination.html);
                }
                else {
                    itemsBlock.find('.grid-wrapper').addClass('empty-block').append('<div class="empty-catalog-text">Отсутствуют товары выборки</div>');
                    paginationBlock.html('');
                }
            },
            error: function (data) {
                $(that).removeClass('loading');
                console.log('Error');
            }
        });
    });

});